import { EntityState, Store } from '@datorama/akita';
import { NgEntityService } from '@datorama/akita-ng-entity-service';
import { HouseholdStore } from '@core/state/household';
import { ApiService } from '@core/services/api/api.service';
import { map, tap } from 'rxjs/operators';

/**
 * NgEntityService modified to work with JSON-style API.
 */
export class StateManagedJsonApi<S extends any> {
  protected endpoint = '';

  constructor(
    private _store: Store,
    private _api: ApiService,
  ) {
  }

  get() {
    return this._api.get(this.endpoint).pipe(
      tap(entities => this._store.update(entities.data)),
      map(data => data.data),
    )
  }
}
